import { initializeApp } from "firebase/app";
import { GoogleAuthProvider, getAuth } from "firebase/auth";
import { initializeFirestore, setLogLevel } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
setLogLevel("debug");

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASEUREMENTID,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
};

export const firebaseApp = initializeApp(firebaseConfig);
export const analytics = getAnalytics(firebaseApp);
const _auth = getAuth();
_auth.languageCode = "fr";
export const auth = _auth;
export const googleAuthProvider = new GoogleAuthProvider();
// export const db = initializeFirestore(firebaseApp, { experimentalAutoDetectLongPolling: true, })

// const analytics = getAnalytics();
// logEvent(analytics, 'screen_view', {
//   firebase_screen: screenName,
//   firebase_screen_class: screenClass
// });
